export class AppStorage {
    public static getItem(key: string): string {
        if (this.isSupported) {
            try {
                return window.localStorage.getItem(key);
            } catch (error) {
                console.warn("Could not get item from local storage: ", error);
                return "";
            }
        }
        return "";
    }

    public static setItem(key: string, value: string): boolean {
        if (this.isSupported) {
            try {
                window.localStorage.setItem(key, value);
                return true;
            } catch (error) {
                console.warn("Could not set item to local storage: ", error);
                return false;
            }
        }
        return false;
    }

    public static removeItem(key: string): boolean {
        if (this.isSupported) {
            try {
                window.localStorage.removeItem(key);
                return true;
            } catch (error) {
                console.warn("Could not remove item from local storage: ", error);
                return false;
            }
        }
        return false;
    }

    public static get isSupported(): boolean {
        return Boolean(window.localStorage);
    }
}